import { defineMessages } from 'react-intl';

export default defineMessages({
    fullName: {
        id: 'Full name',
        defaultMessage: 'Full name'
    },
    dob: {
        id: 'Date of birth',
        defaultMessage: 'Date of birth'
    },
    mainPhoneNumber: {
        id: 'Main phone number',
        defaultMessage: 'Main phone number'
    },
    mainPhoneNumberTooltip: {
        id: '_.tooltip.main_phone_number',
        defaultMessage:
            'We’ll use your phone number to contact you about your application. Don’t worry – it won’t be shared with anyone else.'
    },
    secondaryPhoneNumber: {
        id: 'Additional phone number',
        defaultMessage: 'Additional phone number'
    },
    emailAddressTooltip: {
        id: '_.tooltip.email_address',
        defaultMessage:
            'We’ll use your email address to contact you about your application. Don’t worry – it won’t be shared with anyone else.'
    },
    nonBusinessIncomeQuestion: {
        id: 'Do you have any non-business income?',
        defaultMessage: 'Do you have any non-business income?'
    },
    nonBusinessIncomeField: {
        id: 'Your non-business income (per month, after tax)',
        defaultMessage: 'Your non-business income (per month, after tax)'
    },
    shareCostsWithSpouseQuestion: {
        id: 'Do you share costs with a spouse or partner?',
        defaultMessage: 'Do you share costs with a spouse or partner?'
    },
    personalIncomeAndExpenses: {
        id: 'Your personal income and expenses',
        defaultMessage: 'Your personal income and expenses'
    },
    personalIncomeAndExpensesTooltip: {
        id: '_.tooltip.personal_income_and_expenses',
        defaultMessage:
            'We need to collect data on your income and expenses outside your business in order to run legally required affordability checks'
    },
    soleTraderPersonalExpensesTooltip: {
        id: '_.tooltip.soletrader_personal_expenses',
        defaultMessage:
            'Given you operate as a sole trader, we need to understand your personal income and expenses to ensure that repayments are affordable.'
    },
    personalAddress: {
        id: 'Your personal address',
        defaultMessage: 'Your personal address'
    },
    nonBusinessIncomeAfterTax: {
        id: 'Your non-business income (after tax)',
        defaultMessage: 'Your non-business income (after tax)'
    },
    numberOfDependents: {
        id: 'How many dependents do you have?',
        defaultMessage: 'How many dependents do you have?'
    },
    numberOfDependentsSubText: {
        id: 'Include any children or other family members that are financially dependent on you',
        defaultMessage:
            'Include any children or other family members that are financially dependent on you'
    },
    residentialStatus: {
        id: 'Choose your residential status',
        defaultMessage: 'Choose your residential status'
    },
    partnerIncomeAfterTax: {
        id: 'Your spouse or partners income (after tax)',
        defaultMessage: "Your spouse or partner's income (after tax)"
    },
    privacyPolicyGuarantor: {
        id: 'privacyPolicyGuarantor',
        defaultMessage:
            'I have read the {privacyPolicyLink} and confirm that the guarantor has agreed to the use of their personal data as described. iwoca use credit quotation searches which have no impact on your credit score. A full credit search will only be run if you take a loan.'
    },
    privacyPolicyAgreement: {
        id: 'privacyPolicyAgreement',
        defaultMessage:
            "Since we may require a personal guarantee, we'll run soft credit checks on your personal information with credit reference agencies. This will not affect your credit score when you apply, but we'll do a full credit search if you take funding. We also share data with fraud prevention agencies. If fraud is detected, you could be refused certain services, finance, or employment. We may record your calls for quality control. You can find additional details in our {privacyPolicyLink}. Please tick if you want to continue."
    },
    isShareholder: {
        id: 'Are you a shareholder of the company?',
        defaultMessage: 'Are you a shareholder of the company?'
    },
    firstName: {
        id: 'First name',
        defaultMessage: 'First name'
    },
    lastName: {
        id: 'Last name',
        defaultMessage: 'Last name'
    },
    emailAddress: {
        id: 'Email address',
        defaultMessage: 'Email address'
    }
});
